import * as Sentry from '@sentry/vue';
import { DotBIMDefaultDataSource } from '@xeokit/xeokit-sdk/src/plugins/DotBIMLoaderPlugin/DotBIMDefaultDataSource.js';

export class DataSourceBIM extends DotBIMDefaultDataSource {
  cacheBuster: boolean = false;

  constructor(cfg: any = {}) {
    super(cfg);
    this.cacheBuster = cfg.cacheBuster !== false;
  }

  _cacheBusterURL(url: string) {
    if (!this.cacheBuster) {
      return url;
    }
    const timestamp = new Date().getTime();
    if (url.indexOf('?') > -1) {
      return url + '&_=' + timestamp;
    } else {
      return url + '?_=' + timestamp;
    }
  }

  loadJSON(url: string, ok: (json: any) => void, err: (e: Error) => void) {
    // Avoid checking ok and err on each use.
    const defaultCallback = (_value) => undefined;
    ok = ok || defaultCallback;
    err = err || defaultCallback;

    const processesStore = useProcessesStore();
    const config = useRuntimeConfig();

    const request = new CachedXHR(config.public.URL_EXP_TIME * 1000);
    request.overrideMimeType('application/json');
    request.open('GET', url, true);

    request.onprogress = function (event: ProgressEvent) {
      if (event.lengthComputable) {
        processesStore.updateDownloadProgress(url as string, event.loaded, event.total);
      }
    };

    request.onabort = function (event: ProgressEvent) {
      const error = new Error('Download aborted');
      processesStore.updateDownloadProgress(url as string, event.loaded, event.total, error);
    };

    request.ontimeout = function (event: ProgressEvent) {
      const error = new Error('Download timeout');
      processesStore.updateDownloadProgress(url as string, event.loaded, event.total, error);
    };

    request.addEventListener('finish', async (event) => {
      try {
        const blob = (event as CustomEvent).detail as Blob;
        const json = JSON.parse(await blob.text());
        ok(json);
      } catch (error) {
        Sentry.captureException(error, {
          fingerprint: ['data-source-bim', 'loadJSON', url],
        });

        err(new Error(`utils.loadJSON(): Failed to parse JSON response - ${error}`));
      }
    });

    request.addEventListener(
      'error',
      function (event) {
        err(new Error(`utils.loadJSON() Error: ${event}`));
      },
      false,
    );
    request.send(null);
  }

  getDotBIM(dotBIMSrc, ok, error) {
    this.loadJSON(
      this._cacheBusterURL(dotBIMSrc),
      (json) => {
        ok(json);
      },
      function (errMsg) {
        error(errMsg);
      },
    );
  }
}
